import type { ReactNode } from "react";
import { useModuleBEM } from "@b2bportal/core-themes";
import { IconNameEnum } from "@b2bportal/core-themes";
import { Collapse } from "@material-ui/core";
import { Icon } from "@tenant/ui";
import styles from "./styles.module.scss";

interface FormErrorTextProps {
  error: ReactNode;
}

export const FormErrorText = ({ error }: FormErrorTextProps): JSX.Element => {
  const [block, cn] = useModuleBEM(styles, "FormErrorText");

  return (
    <Collapse className={block} in={!!error}>
      <div className={cn("content")}>
        <Icon
          className={cn("icon")}
          iconName={IconNameEnum.error}
          useCurrentColor={false}
        />
        <span className={cn("text")}>{error}</span>
      </div>
    </Collapse>
  );
};
